// module.exports = require('./src');

import pkg from './src';
export default pkg;


// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-input-label/index.js